import api from "./client";

export const getAnalyticsDashboard = (params = {}) => {
    return api.get("/api/analytics/dashboard/", {
        params,
    });
};
